<template>
    <div class="merged-page">
        <div class="route-page-content">
            <ChatbotMenu v-model="selectedTab" />
            <div class="page-content-wrapper">
                <ChatbotArchive v-if="isSelected('archive')" />
                <Entities v-if="isSelected('entities')" />
                <Training v-if="isSelected('training')" />
                <UserSegments v-if="isSelected('user-segments')" />
                <Plans v-if="isSelected('plans')" />
                <StoryList v-if="isSelected('stories')" />
                <Templates v-if="isSelected('templates')" />
                <AITemplates v-if="isSelected('ai/templates')" />
                <Integrations v-if="isSelected('integrations')" />
                <AllChats v-if="isSelected('reports/all-chats')" />
                <Overall v-if="isSelected('reports/overall')" />
                <BusiestPeriod v-if="isSelected('reports/busiest-period')" />
                <RatingDistribution v-if="isSelected('reports/rating-distribution')" />
                <Popularity v-if="isSelected('reports/popularity')" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import ChatbotMenu from "./ChatbotMenu.vue";
import ChatbotArchive from "./pages/archive/ChatbotArchive.vue";
import Training from "./pages/training/Training.vue";
import Entities from "./pages/entities/Entities.vue";
import UserSegments from "./pages/segments/UserSegments.vue";
import Plans from "./pages/plans/Plans.vue";
import StoryList from "./pages/story-list/StoryList.vue";
import Templates from "./pages/templates/Templates.vue";
import AITemplates from "./pages/templates/AITemplates.vue";
import Integrations from "./pages/integrations/Integrations.vue";
import AllChats from "./pages/reports/AllChats.vue";
import Overall from "./pages/reports/Overall.vue";
import BusiestPeriod from "./pages/reports/BusiestPeriod.vue";
import RatingDistribution from "./pages/reports/RatingDistribution.vue";
import Popularity from "./pages/reports/Popularity.vue";
import ChatbotMenuItems from "./ChatbotMenuItems";

const log = log2("Team");
export default {
    name: "Chatbot",
    components: {
        Popularity,
        RatingDistribution,
        BusiestPeriod,
        Overall,
        AllChats,
        Integrations,
        AITemplates,
        Templates,
        StoryList,
        Plans,
        UserSegments,
        Entities,
        Training,
        ChatbotMenu,
        AppBreadCrumb,
        ChatbotArchive,
    },
    data() {
        return {
            selectedTab: this.$route.path.replace(/(\/chatbot\/|\/chatbot)/g, "") || "stories",
        };
    },
    computed: {
        ...mapState({
            subjects: (state) => state.subject.subjects.data,
            isAdmin: (state) => state.auth.adminUser != null,
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        isSelected(type) {
            const items = ChatbotMenuItems(this);
            const item = items.find((item) => item?.parentKey === this.selectedTab || item.key === this.selectedTab);
            return item.key === type || item.parentKey === type;
        },
        init() {
            this.selectedTab = this.$route.path.replace(/(\/chatbot\/|\/chatbot)/g, "") || "stories";
            const selected = ChatbotMenuItems(this).find((x) => x.key === this.selectedTab);
            if (!selected?.enabled) {
                const available = ChatbotMenuItems(this).find((x) => x.enabled);
                if (available) {
                    this.selectedTab = available.key;
                } else {
                    this.$router.push("/denied");
                }
            }
        },
    },
    created() {
        this.init();
    },
    watch: {
        selectedTab(newVal) {
            this.$router.push(`/chatbot/${newVal}`);
        },
        "$route.path": {
            deep: true,
            handler() {
                this.init();
            },
        },
    },
};
</script>
